import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';
import { viewEnginePiletOverlays } from '@sharefiledev/view-engine-pilet-sdk';
import { BlockNames } from '../block.types';

const LazyViewByRID = React.lazy(() => import('../components/ViewByRID'));

const defaultFallbackView = {
	blocks: [
		{
			blockRID: '',
			blockName: BlockNames.Text,
			blockParameters: {
				text: {
					en: 'View does not exist',
				},
			},
		},
	],
	rid: '',
	name: 'no-view',
	rootBlockRID: '',
};

export const ViewByRIDDrawer: React.FC<
	OverlayDrawerComponentProps<typeof viewEnginePiletOverlays.viewByRIDDrawer>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	if (!options?.viewRID) {
		return <div data-testid="drawer-view-by-rid-error" />;
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-drawer-view-by-rid" />}>
			<LazyViewByRID
				viewRID={options.viewRID}
				cancelInteraction={cancelInteraction}
				completeInteraction={completeInteraction}
				piletApi={piral}
				fallbackView={options.fallbackView ?? defaultFallbackView}
				contractData={options.contractData}
			/>
		</React.Suspense>
	);
};
